import { AfterViewInit, Component, ElementRef, Injector, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Rxjs
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

// Services
import { WebcomponentsService } from '@core/service/webcomponents.service';
import { ExtendTermService } from './service';

// Configs
import { SUCCESS_CODE_ENUMERATION } from './config';

// Swal
import { show_popup } from '@shared/utility/popup-error';

@Component({
  selector: 'app-extend-term',
  templateUrl: './extend-term.component.html',
  styleUrls: ['./extend-term.component.css'],
})
export class ExtendTermComponent implements AfterViewInit, OnDestroy {
  @ViewChild('novationComponent', { static: true }) private novationComponent!: ElementRef;

  public loanId: string;
  public novationTypeId: string;

  private readonly route: ActivatedRoute;
  private readonly router: Router;
  private readonly webElementService: WebcomponentsService;
  private readonly extendTermService: ExtendTermService;
  private readonly unSubscribe$: Subject<void>;
  public loading: boolean;

  constructor(private readonly inject: Injector) {
    this.route = this.inject.get(ActivatedRoute);
    this.router = this.inject.get(Router);
    this.webElementService = this.inject.get(WebcomponentsService);
    this.extendTermService = this.inject.get(ExtendTermService);

    this.loanId = this.route.snapshot.params['id'];
    this.novationTypeId = this.route.snapshot.queryParams?.['novationTypeId'];

    this.unSubscribe$ = new Subject();
    this.loading = false;
  }

  public ngAfterViewInit(): void {
    this.webElementService.isLoaded$.pipe(takeUntil(this.unSubscribe$)).subscribe({
      next: (loaded) => {
        if (loaded) {
          this.novationComponent.nativeElement.ngElementStrategy?.componentRef.instance.build({
            loanId: this.loanId,
            novationTypeId: this.novationTypeId,
          });
        }
      },
    });
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  public continueAction(event: { detail: { requiredPaymentAction: boolean } }): void {
    this.loading = true;
    this.extendTermService
      .command({
        loanId: parseInt(this.loanId),
        novationType: this.novationTypeId,
      })
      .pipe(
        takeUntil(this.unSubscribe$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (response) => {
          if (this.isValidSuccessCode(response.result.code)) {
            const data = { isNovation: true, novationTypeId: this.novationTypeId, loanId: this.loanId };
            event.detail.requiredPaymentAction
              ? this.router.navigate(['value-to-pay', this.loanId], {
                  queryParams: { novationTypeId: this.novationTypeId },
                })
              : this.router.navigate(['payment-status'], { queryParams: data });
          } else {
            show_popup('Error', response.result.message);
          }
        },
        error: () => {
          show_popup('Error', 'Ha ocurrido un error, intenta más tarde');
        },
      });
  }

  public backAction(): void {
    this.router.navigate([`/home`]);
  }

  private isValidSuccessCode(code: string): boolean {
    return Object.values(SUCCESS_CODE_ENUMERATION).includes(code as SUCCESS_CODE_ENUMERATION);
  }
}
